import { Drawer as MuiDrawer, DrawerProps as MuiDrawerProps } from "@mui/material";
import { CodeProvider } from "../contexts/code-context";
import useModalContext from "../hooks/use-modal-context";
import { ModalCodeProps } from "../shared/types";
import useOnClose from "../hooks/use-on-close-effect";

export interface DrawerProps extends Omit<MuiDrawerProps, "open" | "onClose">, ModalCodeProps {
    width?: number | string,
    onClose?: () => any
}

export default function Drawer({
    code,
    children,
    closeAfterTransition,
    anchor = "right",
    width = "450px",
    onClose,
    ...props
}: DrawerProps) {
    const { open, handleClose } = useModalContext(code);

    useOnClose(open, onClose);

    return <MuiDrawer
        {...props}
        open={open}
        onClose={handleClose}
        closeAfterTransition={closeAfterTransition}
        anchor={anchor}
        slotProps={{
            ...props.slotProps,
            paper: {
                sx: { minWidth: `min(${width}, 100vw)`, maxWidth: width },
                ...props.slotProps?.paper
            }
        }}
    >
        <CodeProvider code={code}>
            {children}
        </CodeProvider>
    </MuiDrawer>
}